import Footer from "./views/footer";
import Header from "./views/header";
import "./App.less";
import styles from "./App.module.less";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import {
  Tabs,
  TabHeader,
  TabDropdownItem,
  Iconsvg,
} from "@wk/components-react16";
import { useEffect, useState } from "react";
import { UserProvider, useUser } from "./utils/UserContext";
import { AvatarUserPlaceholder } from "@wk/components-react16";
import logoImg from "@/assets/img/foot_logo.png";

const pathList = ["/player/detail", "/player/personalCases"];
const Navigation = () => {
  const { user, set } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [locationInFo, setLocationInFo] = useState();
  const [isDark, setIsDark] = useState(false);

  // 路由菜单
  const tagsList = [
    {
      name: "大赛首页",
      path: "/",
      breadName: "首页",
    },
    // {
    //   name: "大赛评委",
    //   path: "/judge",
    //   breadName: "大赛评委",
    //   parentPath: "/",
    //   parentName: "首页",
    // },
    {
      name: "往届U选",
      path: "/history",
      breadName: "往届U选",
      parentPath: "/",
      parentName: "首页",
    },
    {
      name: "案例模板",
      path: "/template",
      breadName: "案例模板",
      parentPath: "/",
      parentName: "首页",
    },
    // {
    //   name: "评委详情",
    //   path: "/judge/detail",
    //   breadName: "评委详情",
    //   parentPath: "/judge",
    //   isTagHide: true,
    //   parentName: "大赛评委",
    // },
    {
      name: "作品详情",
      path: "/history/detail",
      breadName: "作品详情",
      parentPath: "/history",
      isTagHide: true,
      parentName: "往届U选",
    },
    {
      name: "登录",
      path: "/login",
      breadName: "登录",
      parentPath: "/",
      isTagHide: true,
      parentName: "首页",
    },

    {
      name: "个人信息",
      path: "/player/detail",
      breadName: "个人信息",
      parentPath: "/player/personalCases",
      isTagHide: true,
      parentName: "选手个人主页",
    },
    {
      name: "选手个人主页",
      path: "/player/personalCases",
      breadName: "选手个人主页",
      parentPath: "/",
      isTagHide: true,
      parentName: "首页",
    },
  ];

  // 当前选中的路由菜单
  const [selectedTab, setSelectedTab] = useState(0);
  // 菜单弹出状态
  const [menuVisible, setMenuVisible] = useState(false);

  // 头像菜单弹出状态
  const [avatarMenuVisible, setAvatarMenuVisible] = useState(false);

  // 切换菜单
  const logUserRequest = (event) => {
    setSelectedTab(event);
    // 路由跳转
    navigate(tagsList[event].path);
    // 关闭菜单
    setMenuVisible(false);
  };

  // 监听路由变化
  useEffect(() => {
    console.log(location);

    setLocationInFo(location);
    const pathName = location.pathname;
    const index = tagsList.findIndex((item) => item.path === pathName);
    setSelectedTab(index);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  useEffect(() => {
    const pathName = location.pathname;
    if (
      (!user || !user?.phone || user?.status !== "1") &&
      pathList.includes(pathName)
    ) {
      navigate("/login");
    }
  }, [user, location]);

  useEffect(() => {
    // 初始化时检测当前主题
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      setIsDark(true);
    }

    // 监听主题变化
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (event) => {
      setIsDark(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);

    // 清理函数，移除事件监听
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  return (
    <div className={styles["App"]}>
      <Header />

      <div className="tagsContainer">
        <div className="first-box">
          <div
            onClick={() => {
              setMenuVisible(!menuVisible);
              setAvatarMenuVisible(false);
            }}
          >
            <Iconsvg name="menu" size={22}></Iconsvg>
          </div>

          <div className="logo-box">
            <img
              data-v-16d0b352=""
              src={
                isDark
                  ? logoImg
                  : "https://qdsyfile.oss-cn-chengdu.aliyuncs.com/project/uptodate/test/logo.png"
              }
              alt="logo"
            />
          </div>
          <div className="right-box">
            {!(user && user?.status === "1") && (
              <div className="login-text" onClick={() => navigate("/login")}>
                登录
              </div>
            )}

            {user && user?.status === "1" && (
              <div
                onClick={() => {
                  setAvatarMenuVisible(!avatarMenuVisible);
                  setMenuVisible(false);
                }}
              >
                <AvatarUserPlaceholder size="extra-small"></AvatarUserPlaceholder>
              </div>
            )}
          </div>
        </div>

        <div className="line-box" />
      </div>
      {menuVisible && (
        <>
          <div
            className="menu-overlay"
            onClick={() => {
              setMenuVisible(false);
              setAvatarMenuVisible(false);
            }}
          ></div>
          <div className="menu-dropdown">
            {tagsList
              .filter((item) => !item.isTagHide)
              .map((item, index) => (
                <div
                  key={index}
                  className={`menu-item ${
                    selectedTab === index ? "active" : ""
                  }`}
                  onClick={() => logUserRequest(index)}
                >
                  {item.name}
                </div>
              ))}
          </div>
        </>
      )}

      {avatarMenuVisible && (
        <>
          <div
            className="menu-overlay"
            onClick={() => {
              setMenuVisible(false);
              setAvatarMenuVisible(false);
            }}
          ></div>
          <div className="menu-dropdown">
            <div
              className="menu-item"
              onClick={() => {
                setAvatarMenuVisible(false);
                navigate("/player/personalCases");
              }}
            >
              选手个人主页
            </div>
            <div
              className="menu-item"
              onClick={() => {
                setAvatarMenuVisible(false);
                set({});
                if (pathList.includes(location.pathname)) {
                  navigate("/");
                }
              }}
            >
              退出登录
            </div>
          </div>
        </>
      )}

      {/* 面包屑 */}
      {tagsList[selectedTab]["parentName"] && (
        <div className="bread-box">
          <div
            className="back-box"
            onClick={() => {
              if (
                locationInFo &&
                locationInFo.state &&
                locationInFo.state.path
              ) {
                let pathItem = tagsList.find(
                  (item) => item.path === locationInFo.state.path
                );
                if (pathItem) {
                  navigate(pathItem.path);
                } else {
                  navigate(tagsList[selectedTab].parentPath);
                }
              } else {
                navigate(tagsList[selectedTab].parentPath);
              }
            }}
          >
            <div>
              <Iconsvg name="chevron-left" size={12} color="#242424"></Iconsvg>
            </div>

            {locationInFo &&
            locationInFo.state &&
            locationInFo.state.path &&
            tagsList.find((item) => item.path === locationInFo.state.path) ? (
              <div className="text">{`返回${
                tagsList.find((item) => item.path === locationInFo.state.path)
                  .breadName
              }`}</div>
            ) : (
              <div className="text">{`返回${tagsList[selectedTab].parentName}`}</div>
            )}
          </div>
          {tagsList[selectedTab].path === "/player/personalCases" && (
            <div className="text" onClick={() => navigate("/player/detail")}>
              个人信息
            </div>
          )}
        </div>
      )}

      <div className={styles["content"]}>
        <Outlet />
      </div>

      <Footer />
    </div>
  );
};

const Index = () => {
  return (
    <UserProvider>
      <Navigation />
    </UserProvider>
  );
};

export default Index;
